import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ReferenceIcon from "../../Icons/ReferenceIcon";

const ReferenceTypeListComponent = loadable(
  () => import("../../components/ReferenceType/ReferenceTypeList"),
);

const ReferenceTypeList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <ReferenceIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Reference Type
        </span>
      </div>
      <ReferenceTypeListComponent />
    </>
  );
};

export default ReferenceTypeList;
